import {PACKAGE_METADATA_TYPE_JSON} from "../../components/package-metadata-viewer";
import {
  getAppLicenseUrl,
  getDatasetExportHtmlMetadataUrl,
  getDatasetExportJsonMetadataUrl,
  getPackageSchemaUrl,
  getPackageUrl,
  getSyncSupersetUrl
} from "../../constants/apiEndpoints";
import {initRequest, RequestMethod} from "../../middlewares/request/requestActions";

/* Dataset Metadata handling */
export const PACKAGE_METADATA_SCHEMA_FETCH = "package/metadata/fetch/schema";
export const PACKAGE_METADATA_FETCH = "package/metadata/fetch";
export const PACKAGE_METADATA_CLEAR = "package/metadata/clear";

export const fetchDataportalPackageMetadataSchema = nodeId =>
  initRequest(PACKAGE_METADATA_SCHEMA_FETCH, getPackageSchemaUrl(nodeId));

export const fetchDataportalPackageMetadata = (nodeId, nodeType, packageId, packageMap, metadataType) => {
  return initRequest(
    PACKAGE_METADATA_FETCH,
    getPackageUrl(nodeId, packageId),
    RequestMethod.GET,
    undefined,
    t => ({
      onStart: t("scenes.dataset.actions.fetchingDatasetMetadata")
    }),
    {
      nodeType: nodeType,
      metadataType: metadataType,
      packageId: packageId,
      packageMap: packageMap
    }
  );
};

export const fetchPackageMetadata = (nodeId, packageId, packageMap, metadataType) => {
  return initRequest(
    PACKAGE_METADATA_FETCH,
    metadataType === PACKAGE_METADATA_TYPE_JSON
      ? getDatasetExportJsonMetadataUrl(nodeId, packageId)
      : getDatasetExportHtmlMetadataUrl(nodeId, packageId),
    RequestMethod.POST,
    undefined,
    t => ({
      onStart: t("scenes.dataset.actions.fetchingDatasetMetadata")
    }),
    {
      metadataType: metadataType,
      packageId: packageId,
      packageMap: packageMap
    }
  );
};

export const clearPackageMetadata = () => ({
  type: PACKAGE_METADATA_CLEAR
});

/**
 * Package load, unload and download events tracking
 */
export const PACKAGE_LOADED = "package/loaded";
export const PACKAGE_UNLOADED = "package/unloaded";
export const PACKAGE_DOWNLOADED = "package/downloaded";

export const packageLoaded = packageId => ({
  type: PACKAGE_LOADED,
  payload: {
    packageId: packageId
  }
});

export const packageUnloaded = packageId => ({
  type: PACKAGE_UNLOADED,
  payload: {
    packageId: packageId
  }
});

export const packageDownloaded = (format, packageId) => ({
  type: PACKAGE_DOWNLOADED,
  payload: {
    format: format,
    packageId: packageId
  }
});

/**
 * Global Redirect Actions
 * Sets an url that is intercepted by the AppDomain which performs a redirect and resets the value.
 * It is used for example as a way to use redirect within middlewares
 */
export const REDIRECT_URL_SET = "redirect/url/set";
export const REDIRECT_URL_UNSET = "redirect/url/unset";

export const setRedirectUrl = url => ({
  type: REDIRECT_URL_SET,
  payload: {
    url: url
  }
});

export const unsetRedirectUrl = () => ({
  type: REDIRECT_URL_UNSET
});

/* License Info handling */
export const APP_LICENSE_FETCH = "app/license/fetch";

export const fetchAppLicense = () => {
  return initRequest(APP_LICENSE_FETCH, getAppLicenseUrl(), RequestMethod.GET, undefined, t => ({
    onStart: t("scenes.license.actions.fetchingLicense")
  }));
};

/* External Tools actions */
export const EXTERNAL_TOOLS_SUPERSET_SYNCHRONIZE = "externalTools/superset/synchronize";

export const supersetSynchronize = nodeId => {
  const formData = new FormData();
  formData.append("json", JSON.stringify({}));

  return initRequest(
    EXTERNAL_TOOLS_SUPERSET_SYNCHRONIZE,
    getSyncSupersetUrl(nodeId),
    RequestMethod.POST,
    formData,
    t => ({
      onStart: t("components.header.actions.externalTools.actions.synchronize")
    })
  );
};
